<div class="card subscribe-card">
    <div class="content-container">
        <div class="content card-content-centered">
            <div class="card-header h1-text" translate>
                unsubscribe.Welcome back!
            </div>
            <div class="card-text field" translate [translateParams]="{email: emailType, school: schoolName}">unsubscribe.You've successfully opted in to receive emails</div>
            <div class="card-text field">
                <a class="btn btn_primary btn_link" translate (click)="gotoEmailPreferences()">unsubscribe.Manage email preferences</a>
            </div>
        </div>
    </div>
</div>
